import React, { useState } from "react";
import "./FloatingForm.css";

const FloatingForm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    service: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Validation functions
  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/.test(email);
  const validatePhone = (phone) => /^\d{10}$/.test(phone);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate email and phone
    if (!validateEmail(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!validatePhone(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    setStatus("Sending...");

   try {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/form/floating-form`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });

  const data = await res.json();

  if (res.ok) {
    alert("Form details sent successfully!");
    setFormData({ name: "", email: "", mobile: "", service: "", message: "" });
    setIsOpen(false);
  }

  setStatus(data.message);
} catch (error) {
  console.error(error);
  setStatus("Something went wrong. Please try again.");
}

  };

  return (
    <>
      {/* Floating Rotated Button → Toggles open/close */}
      <button className="floating-btn" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "Close Enquiry" : "Post an Enquiry"}
      </button>

      {/* Popup Form */}
      <div
        className={`popup-overlay ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(false)}
      >
        <div
          className={`popup-form ${isOpen ? "open" : ""}`}
          onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
        >
          <div className="pp-hero-form">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="mobile"
                placeholder="Your Mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select Course</option>
                <option value="nttmtt">NTT/MTT Course</option>
                <option value="ptt">PTT Course</option>
              </select>
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
              />
              <button type="submit" disabled={status === "Sending..."}>
                {status === "Sending..." ? "Sending..." : "Send Message"}
              </button>
            </form>
            {status && <p className="status">{status}</p>}
          </div>
        </div>
      </div>
    </>
  );
};

export default FloatingForm;
